var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgChartLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.667 10.667a1 1 0 001-1 .514.514 0 000-.1l1.86-1.86h.306L8.907 8.78v.053a1 1 0 102 0V8.78l2.426-2.447a1 1 0 10-1-1 .522.522 0 000 .1L9.927 7.84H9.82L8.667 6.667a1 1 0 00-2 0l-2 2a1 1 0 000 2zm9 2.666H2.333V2A.667.667 0 101 2v12a.667.667 0 00.667.667h12a.667.667 0 000-1.334z",
  fill: "#44494D"
})));
export default __webpack_public_path__ + "static/chartLine.[git-hash].svg";
export { SvgChartLine as ReactComponent };